import React, { useState } from 'react'
import PropTypes from 'prop-types'

import DropdownButton from '../DropdownButton'
import Button from '../Button'

import { renderIcon } from '../utils/helpers'
import { useToggle } from '../utils/hooks'

export const FilePreview = ({
  size = 'sm',
  fileType,
  originalTitle,
  newTitle,
  fileSize,
  previewHandler,
  titleHandler,
  downloadHandler,
  deleteHandler,
  ...other
}) => {
  const [isEdit, toggleEdit] = useToggle()
  const [editText, setEditText] = useState(newTitle || originalTitle)
  const [isSubmitting, toggleSubmitting] = useToggle()

  const documentOptions = () => (
    <DropdownButton
      ghost
      className='btn-sm rounded-0'
      options={[
        {
          content: 'Preview',
          disabled: typeof previewHandler !== 'function',
          onClick: (e) => {
            e.stopPropagation()
            previewHandler?.()
          }
        },
        {
          content: 'Edit Title',
          onClick: (e) => {
            e.stopPropagation()
            toggleEdit()
          }
        },
        {
          content: 'Download',
          disabled: typeof downloadHandler !== 'function',
          onClick: (e) => {
            e.stopPropagation()
            downloadHandler?.()
          }
        },
        {
          content: 'Delete',
          disabled: typeof deleteHandler !== 'function',
          onClick: (e) => {
            e.stopPropagation()
            deleteHandler?.()
          }
        }
      ]}
    >
      <span className='text-muted fas fa-ellipsis fs-6' aria-hidden='true' />
    </DropdownButton>
  )

  return (
    <>
      {
        size === 'md' && <div className={`d-flex alert p-2 ${isEdit ? 'bg-primary-100' : 'bg-light'}`} role='uploaded file' style={{ border: '2px solid #ECECEC', borderRadius: '3px' }} onClick={(e) => {
          if (e.target.classList.contains('dropdown-toggle') || (e.target.classList.contains('fa-ellipsis')) || (e.target.classList.contains('save-cancel'))) {
            return false
          }
          e.stopPropagation()
          // previewHandler?.()
        }}>
          <div className='w-100 d-flex'>
            <div className='bg-primary-500 d-flex justify-content-center align-content-center my-auto me-2'
              style={{ width: '50px', height: '50px' }}
            >
              <span className={`text-white fas ${renderIcon(fileType)} align-self-center fs-2 px-2`} aria-hidden='true' />
            </div>
            {isEdit
              ? <div className='w-100 my-auto'>
                <div className='d-flex active-edit-controls'>
                  <input
                    type='text'
                    className='form-control w-100 rounded-0 me-3 active-edit-controls'
                    disabled={isSubmitting}
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                  />
                  <Button
                    ghost
                    className='save-cancel active-edit-controls me-1'
                    disabled={isSubmitting}
                    onClick={async() => {
                      toggleSubmitting(true)
                      if (editText !== undefined) {
                        await titleHandler?.(editText)
                      }
                      toggleSubmitting(false)
                      toggleEdit(false)
                    }}
                  >
                    {isSubmitting
                      ? <span className='fas fa-spinner fa-spin active-edit-controls' />
                      : <span className='fas fa-check text-success active-edit-controls' />
                    }
                  </Button>
                  <Button
                    ghost
                    className='save-cancel text-muted active-edit-controls'
                    disabled={isSubmitting}
                    onClick={() => {
                      toggleEdit()
                    }}
                  >
                    <span className='fas fa-xmark active-edit-controls' />
                  </Button>
                </div>
              </div>
              : <div className='w-100 ms-2'>
                <p className='text-dark mb-0'>
                  {newTitle
                    ? <>
                      <span className='me-3'>{newTitle}</span>
                      <small className='text-muted text-small'>{originalTitle}</small>
                    </>
                    : originalTitle
                  }
                </p>
                <p className='fs-7 text-muted mb-0'>{fileSize}</p>
              </div>
            }
          </div>
          {!isEdit &&
            <div className='position-absolute top-0 end-0'>
              {documentOptions()}
            </div>
          }
        </div>
      }

      {
        size === 'sm' && <div className={`d-flex alert  ${isEdit ? 'bg-primary-100' : 'bg-light'} p-1 align-items-center`} role='uploaded file' style={{ borderRadius: '3px' }}>
          {isEdit
            ? <div className='w-100'>
              <div className='d-flex active-edit-controls align-items-center'>
                <span className={`text-primary fas ${renderIcon(fileType)} ms-1 me-2`} aria-hidden='true' />
                <input
                  type='text'
                  className='form-control w-100 rounded-0 me-3 active-edit-controls'
                  disabled={isSubmitting}
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                />
                <Button
                  ghost
                  className='save-cancel active-edit-controls me-1'
                  disabled={isSubmitting}
                  onClick={async() => {
                    toggleSubmitting(true)
                    if (editText !== undefined) {
                      await titleHandler?.(editText)
                    }
                    toggleSubmitting(false)
                    toggleEdit(false)
                  }}
                >
                  {isSubmitting
                    ? <span className='fas fa-spinner fa-spin active-edit-controls' />
                    : <span className='fas fa-check text-success active-edit-controls' />
                  }
                </Button>
                <Button
                  ghost
                  className='save-cancel text-muted active-edit-controls'
                  disabled={isSubmitting}
                  onClick={() => {
                    toggleEdit()
                  }}
                >
                  <span className='fas fa-xmark active-edit-controls' />
                </Button>
              </div>
            </div>
            : <span className='text-link text-primary' onClick={() => previewHandler?.()}>
              <span className={`fas ${renderIcon(fileType)} mx-2`} aria-hidden='true' />
              {newTitle
                ? <>
                  <span className='me-3'>{newTitle}</span>
                  <small className='text-muted text-small'>{originalTitle}</small>
                </>
                : originalTitle
              }
            </span>
          }
          {!isEdit &&
            <div className='position-absolute right-0 end-0 me-1'>
              {documentOptions()}
            </div>
          }
        </div>
      }

      {
        size === 'xs' && <span className='text-link text-primary' onClick={() => previewHandler?.()}>
          <span className={`fas ${renderIcon(fileType)} fs-6 mx-2`} aria-hidden='true' />
          {originalTitle}
        </span>
      }
    </>
  )
}

FilePreview.propTypes = {
  deleteHandler: PropTypes.func,
  downloadHandler: PropTypes.func,
  title: PropTypes.any,
  dropdown: PropTypes.bool
}

export default FilePreview
